import React from 'react'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import CardUI from '../../../widgets/layout/CardUI'
import './FailedExternalPage.css'

const FailedExternalPageUI = ({ 
  context, 
  errorList, 
  externalApiCallLogList, 
  lastKey, 
  hasMore, 
  hasPrevious,
  gettingMore,
  currentPage,
  reinitiateSubmitted,
  reinitiateSuccessMsg,
  selectedRequestId,
  onRefreshClick, 
  onNextClick, 
  onPreviousClick,
  onReinitiateClick 
}) => {
  return (
    <SuperUserHomePageUI
      context={context} 
      className='pg_su_failed_external' 
      topnav='accounts'
      page='failedExternal'
      dimension='w1600'
    >
      {
        (!externalApiCallLogList && !errorList) &&
        <SpinnerComponentUI />
      }

      {errorList && errorList.length > 0 && (
        <GenericErrorUI error={errorList[0]} />
      )}

      {
        reinitiateSuccessMsg &&
        <div className='g_success_msg g_m_bottom_25'>
          {reinitiateSuccessMsg}
        </div>
      }

      {
        externalApiCallLogList &&
        <LRTableActionsUI
          location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>External API</b></span>
            </span>
          }
        />
      }

      {
        externalApiCallLogList && externalApiCallLogList.length === 0 && (
          <EmptyListUI context={context} createEnabled={false} createDisabledMessageLabel='No External Failed API' />
        )
      }

      {
        externalApiCallLogList && externalApiCallLogList.length > 0 && (
          <div className='table-container-wrapper'>
            <CardUI className='g_no_margin enhanced-card'>
              <div className='table-header'>
                <div className='table-stats'>
                  <span className='stat-item'>
                    <strong>Total Records:</strong> {externalApiCallLogList.length}
                  </span>
                  <span className='stat-item'>
                    <strong>Page:</strong> {currentPage}
                  </span>
                </div>
              </div>
              <div className='table-scroll-container'>
                <table className='enhanced-table'>
                  <thead>
                    <tr>
                      <th>Item</th>
                      <th>API</th>
                      <th className='attempts-col'>Attempts</th>
                      <th>Status</th>
                      <th>Request Time</th>
                      <th>Response Time</th>
                      <th>Failure Reason</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {externalApiCallLogList.map((log, index) => {
                      const isProcessing = reinitiateSubmitted && selectedRequestId === log.requestId;
                      
                      return (
                        <tr key={index} className={index % 2 === 0 ? 'row-even' : 'row-odd'}>
                          <td>{log.itemId}</td>
                          <td>{log.api}</td>
                          <td className='attempts-col'>{log.attempts}</td>
                          <td>{log.status}</td>
                          <td>{log.requestedAtEpoch ? new Date(log.requestedAtEpoch).toLocaleString() : '-'}</td>
                          <td>{log.responseAtEpoch ? new Date(log.responseAtEpoch).toLocaleString() : '-'}</td>
                          <td>{log.failureReason || '-'}</td>
                          <td>
                            {log.status === 'FAILED' && (
                              <button
                                className={`reinitiate-btn ${isProcessing ? 'processing' : ''}`}
                                onClick={onReinitiateClick}
                                data-request-id={log.requestId}
                                disabled={isProcessing}
                              >
                                {isProcessing ? (
                                  <>
                                    <span className='spinner'></span>
                                    <span>Processing...</span>
                                  </>
                                ) : (
                                  <>
                                    <span className='btn-icon'>🔄</span>
                                    <span>Reinitiate</span>
                                  </>
                                )}
                              </button>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </CardUI>
            {(hasMore || hasPrevious) && (
              <div className='pagination-container'>
                <div className='pagination-buttons'>
                  {hasPrevious && (
                    <button
                      className={`pagination-btn prev-btn ${gettingMore ? 'loading' : ''}`}
                      onClick={onPreviousClick}
                      disabled={gettingMore}
                    >
                      {gettingMore ? (
                        <>
                          <span className='spinner'></span>
                          <span>Loading...</span>
                        </>
                      ) : (
                        <>
                          <span className='btn-icon'>⬅️</span>
                          <span>Previous</span>
                        </>
                      )}
                    </button>
                  )}
                  
                  {hasMore && (
                    <button
                      className={`pagination-btn next-btn ${gettingMore ? 'loading' : ''}`}
                      onClick={onNextClick}
                      disabled={gettingMore}
                    >
                      {gettingMore ? (
                        <>
                          <span className='spinner'></span>
                          <span>Loading...</span>
                        </>
                      ) : (
                        <>
                          <span className='btn-icon'>➡️</span>
                          <span>Next</span>
                        </>
                      )}
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
        )
      }
    </SuperUserHomePageUI>
  )
}

export default FailedExternalPageUI